import { render, staticRenderFns } from "./ListDudi.vue?vue&type=template&id=2fd1666f&scoped=true&"
import script from "./ListDudi.vue?vue&type=script&lang=js&"
export * from "./ListDudi.vue?vue&type=script&lang=js&"
import style0 from "./ListDudi.vue?vue&type=style&index=0&id=2fd1666f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1666f",
  null
  
)

export default component.exports